export type DropDownMenuItemProps = {
  id: number | string
  dataTest?: string
  disabled?: boolean
  group?: string
  iconColorClass?: string
  iconName?: string
  imageSrc?: string
  text: string
}

export type DropDownMenuItemEmits = (e: 'onClickOption', id: DropDownMenuItemProps['id']) => void

export type DropDownMenuEmits = DropDownMenuItemEmits & ((e: 'openDropdown', isOpen: boolean) => void)

export type DropDownViewModel = {
  isMenuOpen: boolean
  dropdownDirection: DropDownDirection
}

export type DropDownMultipleViewModel = {
  filteredOptions: DropDownMenuItemProps[]
  searchText: string
}

export interface IDropDownUseCase {
  viewmodel: DropDownViewModel
  onClickToggle: () => void
}

export interface IDropDownMultipleUseCase {
  viewmodel: DropDownMultipleViewModel
}

export enum DropDownDirection {
  LEFT, RIGHT
}
